// extracted by mini-css-extract-plugin
export var cardIcon = "_4w-4";
export var checkboxCard = "_4w-0";
export var checkboxCardSelected = "_4w-3";
export var disabled = "_4w-1";
export var outerBorder = "_4w-2";
export var spacerMedium = "_4w-7";
export var spacerSmall = "_4w-6";
export var spacerXsmall = "_4w-5";